import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { ConsultationProvider } from "./components/Consultation";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Destinations from "./pages/Destinations";
import DestinationDetail from "./pages/DestinationDetail";
import Institutes from "./pages/Institutes";
import InstituteDetail from "./pages/InstituteDetail";
import Scholarships from "./pages/Scholarships";
import Pathways from "./pages/Pathways";
import Services from "./pages/Services";
import Partner from "./pages/Partner";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import Contact from "./pages/Contact";
import Legal from "./pages/Legal";
import NotFound from "./pages/NotFound";

function SmoothScroll({ children }) {
  const lenisRef = useRef(null);
  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return undefined;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return children;
}

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const timer = setTimeout(() => {
        const el = document.getElementById(hash.slice(1));
        if (!el) return;
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -96 });
        else el.scrollIntoView({ behavior: "smooth" });
      }, 250);
      return () => clearTimeout(timer);
    }
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
    return undefined;
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen bg-ivory">
      <BrowserRouter>
        <SmoothScroll>
          <ConsultationProvider>
            <ScrollManager />
            <Header />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/destinations" element={<Destinations />} />
              <Route path="/destinations/:slug" element={<DestinationDetail />} />
              <Route path="/institutes" element={<Institutes />} />
              <Route path="/institutes/:slug" element={<InstituteDetail />} />
              <Route path="/scholarships" element={<Scholarships />} />
              <Route path="/pathway-programs" element={<Pathways />} />
              <Route path="/services" element={<Services />} />
              <Route path="/partner-with-us" element={<Partner />} />
              <Route path="/news" element={<News />} />
              <Route path="/news/:slug" element={<NewsDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/privacy-policy" element={<Legal page="privacy-policy" />} />
              <Route path="/terms-and-conditions" element={<Legal page="terms-and-conditions" />} />
              <Route path="/cookie-policy" element={<Legal page="cookie-policy" />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <Footer />
            <Toaster position="bottom-right" richColors />
          </ConsultationProvider>
        </SmoothScroll>
      </BrowserRouter>
    </div>
  );
}

export default App;
